import React from 'react';

const StepContext = React.createContext();

export const { Provider, Consumer } = StepContext;
export default StepContext;
